var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[(_vm.protocolContent.length > 0)?_c('div',[_c('div',{staticClass:"item-wrap"},_vm._l((_vm.protocolContent),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(item.configValue)}})])}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }